/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebreviewsubtitle3Inputs */

const en_placewebreviewsubtitle3 = /** @type {(inputs: Placewebreviewsubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check what we found. Every line is editable.`)
};

const de_placewebreviewsubtitle3 = /** @type {(inputs: Placewebreviewsubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüf, was wir gefunden haben. Jede Zeile lässt sich ändern.`)
};

/**
* | output |
* | --- |
* | "Check what we found. Every line is editable." |
*
* @param {Placewebreviewsubtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebreviewsubtitle3 = /** @type {((inputs?: Placewebreviewsubtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebreviewsubtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebreviewsubtitle3(inputs)
	return de_placewebreviewsubtitle3(inputs)
});
export { placewebreviewsubtitle3 as "placeWebReviewSubtitle" }